import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// Icons
import 'font-awesome/css/font-awesome.min.css';

// Navigation
import { useNavigate, Navigate, useParams, Link } from 'react-router-dom';

// Helpers
import Helpers from '../../helpers';

// Css
import '../../assets/css/app.css';

// Layout
import CommerceLayout from '../layouts/CommerceLayout';

// Components
import ShoppingCartForm from '../../components/ShoppingCartForm';

@inject('AuthStore', 'ProductStore', 'ShoppingCartStore', 'StoreStore')
@observer

class ProductDetails extends React.Component<any> {
    state = {
        quantity: 1,
        mainImage: "",
    };

    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        if (this.props.ProductStore.productDatas[this.props.id] === undefined) {
            Helpers.getProduct(this.props.id)
        }
    }

    changeImage = (imageSrc) => {
        this.setState({ mainImage: imageSrc });
    };

    render() {
        const details = this.props.ProductStore.productDatas[this.props.id];
        const { mainImage } = this.state;

        const storeId: any = localStorage.getItem('storeId');
        const storeData = this.props.StoreStore.stores[storeId];

        let currencyData: any = null;
        let price: any = null;

        if (details !== undefined) {
            currencyData = Helpers.convertCurrencyData(details.currency);

            if (Helpers.getUserData().isLogin) {
                price = currencyData !== null ? Helpers.returnPrice(details.id, {
                    price: details.price,
                    ...currencyData
                }) : null;
            } else {
                if (storeData.not_login_view_price !== "not_view") {
                    let productPrice = null;

                    if (storeData.not_login_view_price === "customer_price") {
                        productPrice = details.customer_price;
                    }

                    if (storeData.not_login_view_price === "dealer_price") {
                        productPrice = details.price;
                    }

                    price = currencyData !== null ? Helpers.returnPrice(details.id, {
                        price: productPrice,
                        ...currencyData
                    }) : null;
                }
            }
        }

        return (
            storeId !== null ?
                <CommerceLayout
                    title={Helpers.translation('update')}
                >
                    {
                        details !== undefined &&
                        <>
                            <section id="breadcrumbs" className="pt-6 bg-gray-50">
                                <div className="container mx-auto px-4 text-xs md:text-base">
                                    <ol className="list-reset flex">
                                        <li>
                                            <Link
                                                className="font-semibold hover:text-primary"
                                                to={`/home`}
                                            >
                                                {Helpers.translation('home')}
                                            </Link>
                                        </li>
                                        <li>
                                            <span className="mx-2">&gt;</span>
                                        </li>
                                        <li>
                                            <Link
                                                className="font-semibold hover:text-primary"
                                                to={`/products`}
                                            >
                                                {Helpers.translation('shop')}
                                            </Link>
                                        </li>
                                        <li>
                                            <span className="mx-2">&gt;</span>
                                        </li>
                                        <li>
                                            {
                                                details.product_categories.data.map((category: any) => {
                                                    return (
                                                        <Link
                                                            className="font-semibold hover:text-primary"
                                                            to={`/products/category/${category.id}`}
                                                        >
                                                            {category.attributes.title}
                                                        </Link>
                                                    )
                                                })
                                            }
                                        </li>
                                        <li>
                                            <span className="mx-2">&gt;</span>
                                        </li>
                                        <li>{details.title}</li>
                                    </ol>
                                </div>
                            </section>

                            <section id="product-info">
                                <div className="container mx-auto">
                                    <div className="py-6">
                                        <div className="flex flex-col lg:flex-row gap-6">
                                            {/* Image Section */}
                                            <div className="w-full lg:w-1/2">
                                                <div className="grid gap-4">
                                                    {/* Big Image */}
                                                    <div className="border border-gray-light rounded-md overflow-hidden">
                                                        {
                                                            mainImage === "" ?
                                                                details.main_image.data !== null ?
                                                                    <img
                                                                        id="main-image"
                                                                        className="h-auto w-full max-w-full rounded-lg object-contain object-center md:h-[480px]"
                                                                        src={Helpers.getBiggestImageUrl(details.main_image.data.attributes)}
                                                                        alt="Main Product"
                                                                    />
                                                                    :
                                                                    <img
                                                                        id="main-image"
                                                                        className="h-auto w-full max-w-full rounded-lg object-contain object-center md:h-[480px]"
                                                                        src={require('../../assets/images/no-image.png')}
                                                                        alt="Main Product"
                                                                    />
                                                                :
                                                                <img
                                                                    id="main-image"
                                                                    className="h-auto w-full max-w-full rounded-lg object-contain object-center md:h-[480px]"
                                                                    src={mainImage}
                                                                    alt="Main Product"
                                                                />
                                                        }
                                                    </div>

                                                    {/* Small Images */}
                                                    <div className="grid grid-cols-5 gap-4">
                                                        {
                                                            details.main_image.data !== null &&
                                                            <img
                                                                onClick={() => this.changeImage(Helpers.getBiggestImageUrl(details.main_image.data.attributes))}
                                                                className="object-contain object-center h-16 lg:h-24 max-w-full rounded-lg cursor-pointer border border-gray-light rounded-md overflow-hidden"
                                                                src={Helpers.getSmallestImageUrl(details.main_image.data.attributes)}
                                                                alt="Main Product"
                                                            />
                                                        }

                                                        {
                                                            details.images.data !== null &&
                                                            details.images.data.map((image: any, index: number) => {
                                                                return (
                                                                    <div key={index}>
                                                                        <img
                                                                            onClick={() => this.changeImage(Helpers.getBiggestImageUrl(image.attributes))}
                                                                            src={Helpers.getSmallestImageUrl(image.attributes)}
                                                                            className="object-contain object-center h-16 lg:h-24 max-w-full rounded-lg cursor-pointer border border-gray-light rounded-md overflow-hidden"
                                                                            alt={`Gallery Image ${index + 1}`}
                                                                        />
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Product Details Section */}
                                            <div className="w-full lg:w-1/2 flex flex-col">
                                                <div className="pb-8">
                                                    <h1 className="text-3xl font-bold mb-4">{details.title}</h1>
                                                    <div className="mb-4 pb-4 border-b border-gray-line">
                                                        <p className="mb-2">
                                                            {Helpers.translation('store')}:
                                                            <strong>
                                                                <a href="#" className="hover:text-primary">
                                                                    {" "}
                                                                    {details.stores.data.map((store: any) => {
                                                                        return store.attributes.title;
                                                                    }).join(' - ')}
                                                                </a>
                                                            </strong>
                                                        </p>

                                                        <p className="mb-2">
                                                            {Helpers.translation('product_code')}:<strong> {details.code}</strong>
                                                        </p>

                                                        {
                                                            storeData.visible_stock &&
                                                            <p className="mb-2">
                                                                {Helpers.translation('stock')}:<strong> {Helpers.getProductStock(details)}</strong>
                                                            </p>
                                                        }
                                                    </div>

                                                    <div className="font-semibold">
                                                        {
                                                            price !== null ?
                                                                price.discountPrice !== 0 ?
                                                                    <>
                                                                        <span className="text-2xl font-bold text-primary">
                                                                            {price.discountPriceWithSymbol}
                                                                        </span>
                                                                        <span className="text-xl line-through  ml-2">{price.withSymbol}</span>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        <span className="text-2xl font-bold text-primary">
                                                                            {price.withSymbol}
                                                                        </span>
                                                                    </>
                                                                :
                                                                <span className="text-2xl font-bold text-primary">
                                                                    {Helpers.translation('ask_for_price')}
                                                                </span>
                                                        }
                                                    </div>

                                                    {
                                                        Helpers.getUserData().isLogin &&
                                                        (storeData.non_stock_order && price !== null) &&
                                                        <div className="flex items-center mb-8">
                                                            <ShoppingCartForm
                                                                productDetails={details}
                                                                storeId={storeId}
                                                            />
                                                        </div>
                                                    }
                                                </div>

                                                {/* Additional Information */}
                                                {
                                                    details.description !== null &&
                                                    <div className="mt-2">
                                                        <h3 className="text-lg font-semibold mb-2">{Helpers.translation('description')}</h3>
                                                        <p>
                                                            {details.description}
                                                        </p>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </>
                    }
                </CommerceLayout>
                :
                <Navigate to="/" replace={true} />
        )
    }
}

function WithNavigate(props: any) {
    let navigate = useNavigate();
    const { id } = useParams();

    props = {
        ...props,
        id
    }

    return <ProductDetails {...props} navigate={navigate} />
}

export default WithNavigate